import { ChevronDownIcon, SignOutIcon } from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Text } from '@primer/react';
// import {Text} from '@primer/react'
import { useDispatch, useSelector } from 'react-redux';
import { useLanguage } from "../../hooks/useLanguage";
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
import UserAvatar from "../user-avatar";
const UserIcon = () => {
    const { user_info } = useSelector((x: RootState) => x.auth)
    return (
        <Box sx={{ mr: -2, mt: "2px" }}>
            <UserAvatar
                fullName={user_info?.full_name}
                url={`${user_info?.img}`}
                size="medium"
            />
        </Box>
    )
}
const UserPanel = () => {
    const { user_info } = useSelector((x: RootState) => x.auth)
    const { language } = useLanguage();
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(actions.account.logOutStart())
    }
    return (
        <ActionMenu>
            <ActionMenu.Button aria-label="Select school year"
                trailingAction={ChevronDownIcon}
                leadingVisual={UserIcon}
                sx={{
                    height: "32px",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.2)!important"
                }}
            >
                <></>
            </ActionMenu.Button>

            <ActionMenu.Overlay>
                <ActionList>

                    <ActionList.Item>
                        <Text sx={{
                            fontWeight: "bold"
                        }}>{user_info?.full_name}</Text>
                        <br />
                        <Text>{user_info?.username}</Text>
                    </ActionList.Item>
                    <ActionList.Divider />
                    <ActionList.Item variant="danger" onClick={handleLogout}>
                        <ActionList.LeadingVisual>
                            <SignOutIcon />
                        </ActionList.LeadingVisual>
                        {language === "en" ? "Log out" : "Đăng xuất"}
                    </ActionList.Item>
                </ActionList>
            </ActionMenu.Overlay>
        </ActionMenu>

    );
};

export default UserPanel;